import { Search } from 'lucide-react-native';
import type { ReactNode } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { colors } from '@/src/theme/colors';

import { BrandLogo } from './BrandLogo';
import { HeaderBackButton } from './HeaderBackButton';

type AuthenticatedHeaderProps = {
  backFallbackPath?: string;
  forceBackFallback?: boolean;
  right?: ReactNode;
};

export function AuthenticatedHeader({
  backFallbackPath,
  forceBackFallback = false,
  right,
}: AuthenticatedHeaderProps) {
  return (
    <SafeAreaView edges={['top']} style={styles.safeArea}>
      <View style={styles.header}>
        <View style={styles.sideSlot}>
          <HeaderBackButton
            fallbackPath={backFallbackPath}
            forceFallback={forceBackFallback}
          />
        </View>
        <BrandLogo size="sm" />
        <View style={styles.sideSlot}>
          {right ?? <View style={styles.placeholder} />}
        </View>
      </View>
    </SafeAreaView>
  );
}

export function AuthenticatedHeaderSearchButton({
  onPress,
}: {
  onPress: () => void;
}) {
  return (
    <Pressable
      accessibilityLabel="Search Frienzzi"
      accessibilityRole="button"
      onPress={onPress}
      style={({ pressed }) => [
        styles.iconButton,
        pressed ? styles.iconButtonPressed : null,
      ]}
    >
      <Search color={colors.text} size={22} strokeWidth={2.4} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    backgroundColor: colors.surface,
    borderBottomColor: colors.border,
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    height: 50,
    justifyContent: 'space-between',
  },
  sideSlot: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
  },
  placeholder: {
    height: 40,
    width: 40,
  },
  iconButton: {
    alignItems: 'center',
    borderRadius: 20,
    height: 40,
    justifyContent: 'center',
    width: 40,
  },
  iconButtonPressed: {
    backgroundColor: colors.surfacePressed,
  },
});
